import { useMemo } from 'react';
import moment from 'moment';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import { Form } from 'dash-ui';
import { DATE_FORMAT } from 'dash-common';

const CreationDateSelect = ({
  value,
  setCreatedAt,
}: {
  value: string;
  setCreatedAt: (value: string) => void;
}) => {
  const { t } = useTranslation(['pages', 'common']);
  const options = useMemo(
    () => [
      {
        value: moment().format(DATE_FORMAT),
        label: capitalize(t(`common:labels:today`) as string),
      },
      {
        value: moment().startOf('week').format(DATE_FORMAT),
        label: capitalize(
          t(`common:labels:dateRangePeriods:currentWeek`) as string
        ),
      },
      {
        value: moment()
          .date(-1 * moment().startOf('week').date())
          .format(DATE_FORMAT),
        label: capitalize(
          t(`common:labels:dateRangePeriods:pastWeek`) as string
        ),
      },
      {
        value: moment().startOf('month').format(DATE_FORMAT),
        label: capitalize(
          t(`common:labels:dateRangePeriods:currentMonth`) as string
        ),
      },
      {
        value: moment()
          .month(moment().month() - 1)
          .format(DATE_FORMAT),
        label: capitalize(
          t(`common:labels:dateRangePeriods:pastMonth`) as string
        ),
      },
      {
        value: moment()
          .month(moment().month() - 3)
          .format(DATE_FORMAT),
        label: capitalize(
          t(`common:labels:dateRangePeriods:threeMonth`) as string
        ),
      },
    ],
    [t]
  );

  return (
    <Form.Group w="100%" mb={5}>
      <Form.Label md>{t('pages:propertyPage:appearedDate')}</Form.Label>
      <Form.Select
        w="100%"
        isSearchable={false}
        menuPlacement="top"
        value={value}
        options={options}
        onChanged={(value) => setCreatedAt(value as string)}
      />
    </Form.Group>
  );
};

export default CreationDateSelect;
